export default function StatsCard({stats = {
    header: {
        title: 'world',
        subtitle: 'rating'
    },
    body: {
        top: 586,
        bottom: 'top 1%'
    },
    footer: [{
        top: 654,
        bottom: 'moving'
    }, {
        top: 546,
        bottom: 'no move'
    }, {
        top: '-',
        bottom: 'nmpz'
    }],
    loading: false,
    liveStats: false
}}) {
    const {header, body, footer, loading, liveStats} = stats;
    const footerCard = (
        <div class="stats-card-footer">
            {footer.map((item, index) => {
                return (
                    <div class="stats-card-footer-stat" key={index}>
                        <div class="stat">{item.top}</div>
                        <div class="stat-game-mode">{item.bottom}</div>
                    </div>
                );
            })}
        </div>
    );
    return (
        <div className={`stats-card ${loading ? 'loading': ''} ${liveStats ? 'live-stats' : ''}`}>
            <div class="stats-card-header">
                <div class="header-title">{header.title}</div>
                <div class="header-subtitle">{header.subtitle}</div>
            </div>
            <div class="stats-card-body">
                <div class="stat">{body.top}</div>
                <div class="stat-bottom">{body.bottom}</div>
            </div>
            {footerCard}
        </div>
    )
};
